export type { MenuProps, MenuItemProps } from "@mantine/core";
export { Menu } from "./Menu";
export { menuOverrides } from "./Menu.config";
